import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { PermissionsService } from '@core/services/permissions.service';

@Injectable()
export class PermissionGuard implements CanActivate {
  constructor(private _permissionsService: PermissionsService) {}
  canActivate(
    route: ActivatedRouteSnapshot,
  ): MaybeAsync<GuardResult> {

    let permission = route.data.permission as string;
    return this._permissionsService.isPermissionEnabled(permission);
  }
}
